import { React, Component, _ } from 'utils';
import { Creators, ResumeStore, Campaigns } from 'model';

export default class SelectableCampaign extends Component {

	handleSelect = () => {
		var { onSelect, campaign } = this.props;

		if(onSelect) {
			onSelect(campaign);
		}
	}

	handleMove = () => {
		Creators.hideFolders();

		var resumes = ResumeStore.getSelected();
		var { campaign } = this.props;

		Creators.move(resumes, campaign);
	}

	render() {
		var { campaign, selected } = this.props;

		var confirm = '';

		if(selected) {
			confirm = <input type="button" onClick={this.handleMove} className="btn btn-primary" value={ _('Spremi')} />
		}

		return <div className={ selected?'selected':'' }>
			<div className="campaign-name">
				<label><input type="radio" name="selected-campaign" checked={selected} onClick={ this.handleSelect } />
					<i className="fa fa-folder-o"></i>
					{ campaign.title } ({ campaign.applications })
				</label>
				{confirm}
			</div>
		</div>
	}
}


// WEBPACK FOOTER //
// ./src/modules/campaign/SelectableCampaign.js